<template>

    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="28px" height="28px"
	 viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">

<g>
	<g>
		<g>
			<path class="st0" d="M16.6,0.8C16.2,0.3,15.6,0,15,0s-1.2,0.3-1.6,0.8C11.9,2.9,4,13.6,4,19c0,6.1,4.9,11,11,11s11-4.9,11-11
				C26,13.6,18.1,2.9,16.6,0.8z M15,28.1c-5,0-9.1-4.1-9.1-9.1c0-4,5.7-12.6,9-17.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0
				c3.4,4.5,9,13.1,9,17.1C24.1,24,20,28.1,15,28.1z"/>
			<path class="st0" d="M15,23c-2.2,0-4-1.8-4-4c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,3.3,2.7,6,6,6c0.6,0,1-0.4,1-1C16,23.5,15.6,23,15,23
				z"/>
		</g>
	</g>
</g>
</svg>

</template>

<script>
    export default {
        name: "HB_svg"
    }
</script>




// WEBPACK FOOTER //
// src/common/components/svg/chapter/HB_svg.vue